<template>
  <!-- 날짜 선택 -->
  <div class="formBox">
    <p class="formTitle">{{info.name[lang]}}</p>
    <!-- 날짜 -->
    <div class="formGroup isRequired mb15 notranslate">
      <label class="label toCapitalize">{{locale.select_date}}</label>
      <div class="fullCalendar" data-custom="calendar">
        <vc-date-picker
          is-inline
          is-expanded
          is-required
          v-model="date"
          mode="date"
          :value="null"
          :attributes="calendarAttr"
          :disabled-dates="disabledDates"
          :locale="ln"
          @input="getReservationInfo" />
      </div>
      <p class="input mt5">{{reserveDate ? setDateFormat(reserveDate) : locale.message_select_date}}</p>
    </div>
    <!-- //날짜 -->
  </div>
  <!-- //날짜 선택 -->
</template>

<script>
import moment from 'moment/moment'
import regExp from '@/common/regExp'
import Summary from '@/components/Reservation/Summary'
import SeatMap from '@/components/Reservation/SeatMap'

export default {
  name: 'ReservationFormDate',
  props: [
    'lang',
    'ln',
    'locale',
    'permission',
    'info',
    'roomKey',
    'guestInfo',
    'rid',
    'isStaff',
    'isPublic',
    'reserveDate',
    'cancelDate'
  ],
  computed: {
    dateFormat () {
      return this.$store.getters['common/getDateFormat']
    },
    // 달력 선택불가 날짜 설정
    disabledDates () {
      const weekday = this.info.dayOfWeek.filter(x => !x.available).map(x => x.weekday)
      const disabledDays = this.info.disabledDays.map(x => x.id)
      const allowedToday = this.info.allowedToday || this.isStaff
      const allowedStay = !(this.info.preArrival || this.info.availableType === 'visitor') && !this.isStaff // 투숙기간내로 제한
      const guestInfo = this.guestInfo
      const stayBefore = guestInfo && guestInfo.stayBefore
      const stayAfter = guestInfo && guestInfo.stayAfter
      const range = Number(regExp.numberOnly(this.info.range))
      const rangeFrom = allowedToday
        ? moment().set({ hour: 0, minute: 0 }).add(-1, 'days')
        : moment().set({ hour: 0, minute: 0 })
      const rangeTo = moment().set({ hour: 0, minute: 0 }).add(range + 1, 'days')
      let dates = [{ weekdays: weekday }]
      if (!this.permission) {
        dates.push({
          start: moment(),
          end: moment()
        })
      }
      if (allowedStay) {
        if (!this.roomKey && !this.rid) {
          dates.push({
            start: moment(),
            end: moment()
          })
        } else if (stayAfter && stayBefore) { // 투숙기간만
          dates.push({
            start: null,
            end: moment(stayAfter).add(-1, 'days').endOf('day').toISOString()
          })
          dates.push({
            start: moment(stayBefore).add(1, 'days').startOf('day').toISOString(),
            end: null
          })
        }
      }
      dates.push({
        start: null,
        end: rangeFrom.toISOString()
      })
      dates.push({
        start: rangeTo.toISOString(),
        end: null
      })
      if (disabledDays.length) {
        disabledDays.forEach(function (x) {
          dates.push(new Date(x))
        })
      }
      return dates
    },
    isToday () {
      return this.date && moment(this.date).isSame(moment(), 'day')
    }
  },
  watch: {
    cancelDate (date) {
      if (date && moment(this.date).format('YYYY-MM-DD') === date) {
        this.date = null
        this.force = true
      } else {
        this.force = false
      }
      // this.date
    }
  },
  data () {
    return {
      date: null,
      force: false,
      calendarAttr: [
        {
          bar: 'orange',
          dates: new Date()
        }
      ]
    }
  },
  methods: {
    setDateFormat (date) {
      return moment(date).format(this.dateFormat.toUpperCase())
    },
    getReservationInfo (date) {
      if (!this.force) {
        this.$emit('setDate', moment(date).format('YYYY-MM-DD'))
      } else {
        this.force = false
      }
    }
  }
}
</script>

